import CanvasController from './canvas-controller.js';
import { computeSpectrogram } from '../chirp-things.js';

export default class SpectrogramController extends CanvasController {

    constructor(id, width, height) {
        super(id, width, height);
        
        this.signal = [];
        this.spectrogram = [];
        this.windowSize = 32;
        this.hopSize = 4;
        
        this.colormap = this.generateColormap();
    }

    setSignal(signal) {
        this.signal = signal;
        this.updateSpectrogram();
    }

    setWindowSize(size) {
        this.windowSize = size;
        this.updateSpectrogram();
    }

    updateSpectrogram() {
        if (this.signal.length === 0) return;
        this.spectrogram = computeSpectrogram(this.signal, this.windowSize, this.hopSize);
    }

    generateColormap() {
        const colors = [];
        for (let i = 0; i < 256; i++) {
            const t = i / 255;
            const r = Math.floor(255 * Math.min(1, t * 2));
            const g = Math.floor(255 * Math.min(1, Math.max(0, (t - 0.25) * 2)));
            const b = Math.floor(255 * Math.min(1, Math.max(0, (t - 0.5) * 2)));
            colors.push(`rgb(${r},${g},${b})`);
        }
        return colors;
    }

    update(dt, mousePosition) {
    }

    render() {
        this.clear();
        this.context.save();
        
        this.renderWaveform();
        this.renderSpectrogram();
        
        this.context.restore();
    }

    renderWaveform() {
        if (this.signal.length === 0) return;
        
        const waveHeight = 60;
        const waveY = 40;
        const margin = 20;
        const waveWidth = this.canvas.width - 2 * margin;
        
        this.context.strokeStyle = '#4a9eff';
        this.context.lineWidth = 1.5;
        this.context.beginPath();
        
        for (let i = 0; i < this.signal.length; i++) {
            const x = margin + (i / this.signal.length) * waveWidth;
            const y = waveY - this.signal[i] * (waveHeight / 2);
            
            if (i === 0) {
                this.context.moveTo(x, y);
            } else {
                this.context.lineTo(x, y);
            }
        }
        this.context.stroke();
    }

    renderSpectrogram() {
        if (this.spectrogram.length === 0) return;
        
        const margin = 20;
        const spectroTop = 80;
        const spectroHeight = this.canvas.height - spectroTop - margin;
        const spectroWidth = this.canvas.width - 2 * margin;
        
        const numTimeSteps = this.spectrogram.length;
        const numFreqBins = this.spectrogram[0].length;
        
        const cellWidth = spectroWidth / numTimeSteps;
        const cellHeight = spectroHeight / numFreqBins;
        
        let maxVal = 0;
        for (const row of this.spectrogram) {
            for (const val of row) {
                if (val > maxVal) maxVal = val;
            }
        }
        if (maxVal === 0) maxVal = 1;
        
        for (let t = 0; t < numTimeSteps; t++) {
            for (let f = 0; f < numFreqBins; f++) {
                const val = this.spectrogram[t][f] / maxVal;
                const colorIdx = Math.min(255, Math.floor(val * 255 * 3));
                
                this.context.fillStyle = this.colormap[colorIdx];
                this.context.fillRect(
                    margin + t * cellWidth,
                    spectroTop + (numFreqBins - 1 - f) * cellHeight,
                    cellWidth + 1,
                    cellHeight + 1
                );
            }
        }
        
        this.context.strokeStyle = '#666';
        this.context.lineWidth = 1;
        this.context.strokeRect(margin, spectroTop, spectroWidth, spectroHeight);
        
        this.context.fillStyle = '#999';
        this.context.font = '12px sans-serif';
        this.context.fillText('Time →', margin + spectroWidth / 2 - 20, this.canvas.height - 5);
        
        this.context.save();
        this.context.translate(10, spectroTop + spectroHeight / 2);
        this.context.rotate(-Math.PI / 2);
        this.context.fillText('Frequency →', -30, 0);
        this.context.restore();
    }
}
